<article class="competing-time-slots-datatable">
  <table mat-table [dataSource]="dataSource" class="mat-table-container">
    <ng-container matColumnDef="timeSlot">
      <th mat-header-cell *matHeaderCellDef>Tranche horaire</th>
      <td mat-cell *matCellDef="let element">{{ element.timeSlot }}</td>
    </ng-container>
    <ng-container matColumnDef="media">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">{{ element.media }}</td>
    </ng-container>
    <ng-container matColumnDef="numberOfAds">
      <th mat-header-cell *matHeaderCellDef>Nombre de pubs</th>
      <td mat-cell *matCellDef="let element">{{ element.numberOfAds }}</td>
    </ng-container>
    <ng-container matColumnDef="dominantCompetitor">
      <th mat-header-cell *matHeaderCellDef>Concurrent dominant</th>
      <td mat-cell *matCellDef="let element">
        {{ element.dominantCompetitor }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="openAddDialog()"
      class="competing-time-slots-datatable__table-line"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
